import { companyApis } from '@apis/companyApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useCompanyStaffs = createUseQuery(
  (page: number) => ['/company/staff/', { page: page + 1 }],
  (page: number) => () =>
    companyApis
      .get('/company/staff/', {
        query: {
          page: page + 1,
        },
      })
      .then((r) => r[200]),
);
